import { USER_GCAL_CALENDARS_LIST } from 'infra/actions/types'

const updateUserImportedCalendars = calendars => ({
  type: USER_GCAL_CALENDARS_LIST,
  payload: calendars
})

export default updateUserImportedCalendars



// WEBPACK FOOTER //
// ./src/infra/actions/gcal/updateUserImportedCalendars.js